import css from 'styled-jsx/css';

const styles = css`:root {
    /* @TODO get a hold of/unify these colors...
       tell design to stop giving us a new color palatte
       with each new design...
    */

    /* New II Design Pattern - Introduced 11-12-2019 */
    /* TODO: --grey-800 is the color for primary text and should be used throughout the entire application */
}
:root {

    /* Margin and padding should be in multiples of 8 (i.e.---8, 16, 24) */

    /* New II Design Pattern - Introduced 11-12-2019 */
}
:root {

    /* New II Design Pattern - Introduced 11-12-2019 */
}
/* @import '@trp-beacon-ui-kit/foundation/style-tokens/css/variables.css'; */
.wrapper {
    background: #f7f9fa;
    padding-bottom: 20px;
}
.browse-all {
    border-left: 4px solid #c4c4c4;
    padding-left: 12px;
}
.browse-all.sf-custom {
    display: inline-block;
    margin-top: calc(8px * 3);
    margin-left: 8px;
    margin-right: 8px;
    font-family: 'Nimbus Sans';
    line-height: 28px;
    font-weight: bold;
}
.browse-all.sf-custom.sf-review-criteria {
    margin-left: 0;
    padding-left: 0;
    border: none;
}
.sf-review-criteria button {
    font-family: 'Nimbus Sans';
    line-height: 28px;
    font-weight: bold;
    color: #006894;
}
.directlandingpage {
  max-width: 1230px;
  padding-left: 32px;
  padding-right: 32px;
  margin: 0 auto;
    padding-bottom: 8px;
    display: flex;
}
.iclass-disclaimer {
  max-width: 1230px;
  padding-left: 32px;
  padding-right: 32px;
  margin: 0 auto;
    padding-bottom: 8px;
    display: flex;
    align-items: center;
}
.learnmore-summit {
    font-size: 18px;
    color: #086ea1;
    text-decoration: none;
    font-weight: normal;
}
.text-col {
    flex: 1;
}
.browse-all :global(a) {
    color: #086ea1;
    text-decoration: none;
}
.text-col-body {
    max-width: 580px;
    display: block;
    margin-left: auto;
    padding-left: 0px;
    padding-right: 70px;
}
.med-text-col-body {
    max-width: 800px;
}
.text-col-body a {
    color: #086ea1;
    text-decoration: none;
    cursor: pointer;
}
.tab-label br {
    display: none;
}
.info-col,
.img-col {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
}
.text-col .ready-wrapper,
.text-col .browse-all {
    display: none;
}
.sml-img-col {
    flex: 25%;
}
.img-col img {
    display: block;
    margin-left: auto;
    width: 473px;
}
.info-col {
    flex: 1;
    display: flex;
    margin-top: calc(8px * 7);
}
.info-col img {
    display: block;
    margin-left: auto;
    width: 473px;
}
.info-col img.small-check-mrk {
    display: inline-block;
    margin: 0;
    width: auto;
    padding-right: 8px;
}
.img-col img.flipped {
    -webkit-transform: scaleX(-1);
    transform: scaleX(-1);
    -webkit-filter: FlipH;
            filter: FlipH;
    -ms-filter: 'FlipH';
}
.sf-blurb {
    font-family: 'Nimbus Sans';
    font-size: 24px;
    font-style: normal;
    font-weight: 400;
    line-height: 27px;
}
h1 {
    margin-top: 24px;
    margin-bottom: 24px;
    font-family: 'Nimbus Sans Light', sans-serif;
    font-size: 48px;
    font-weight: normal;
}
h1.select-funds-title {
    font-family: 'Nimbus Sans';
    line-height: calc(8px * 7);
    margin-bottom: calc(8px * 2);
}
h2 {
    font-family: 'Nimbus Sans', sans-serif;
    font-size: 24px;
    font-weight: normal;
}
p {
    font-family: 'Nimbus Sans Light', sans-serif;
    font-size: 18px;
    margin-bottom: 30px;
}
p.listed-content {
    font-size: 24px;
    margin-bottom: calc(8px * 2);
    margin-top: calc(8px * 2);
    color: #3b4b59;
    font-family: 'Nimbus Sans';
    line-height: calc(8px * 4);
}
blockquote {
    font-family: 'Nimbus Sans Light', sans-serif;
    font-size: 18px;
    border-left: 4px solid #06c3df;
    margin-left: 0;
    margin-bottom: 32px;
    padding-left: 12px;
}
.ready-wrapper span {
    font-size: 18px;
    font-family: 'Nimbus Sans', sans-serif;
    font-weight: normal;
}
.text-col .ready-wrapper {
    padding-bottom: calc(8px * 2);
}
.ready-wrapper a {
    font-size: 18px;
    color: #086ea1;
    text-decoration: none;
    font-weight: normal;
}
.ready-wrapper .intro {
    display: block;
    margin-bottom: 8px;
}
.modal {
    padding: 16px;
    margin-left: auto;
    margin-right: auto;
    width: 600px;
}
.modal-title {
    font-family: 'Nimbus Sans Bold', sans-serif;
    font-size: 16px;
    margin-bottom: 16px;
}
/* TABS */
/*stylelint-disable*/
.SI-tabview-container .show {
    display: block;
}
.SI-tabview-container .SI-nav {
    text-align: center;
    border-bottom: 1px solid #b1b1b1;
    font-family: 'Nimbus Sans Light', sans-serif;
    margin: 0;
    display: flex;
    line-height: 26px;
}
.SI-tabview-container .SI-tab-label {
    float: left;
    width: 33.33%;
}
.SI-tabview-container .SI-tab-label a {
    font-size: 18px;
    color: #767676;
    text-decoration: none;
    cursor: pointer;
}
.SI-tab-label > a > div {
    padding: 0 0 4px;
}
.SI-tabview-container .visited {
    border-bottom: 4px solid #767676;
}
.SI-tab-label:hover,
.SI-tab-label a:hover {
    color: #054c70;
    border-bottom: 4px solid #054c70;
}
.SI-nav .active,
.SI-nav .active > a {
    border-top: 0;
    border-bottom: 4px solid #086ea1;
    font-size: 18px;
    color: #086ea1;
    font-weight: 400;
}
.SI-tab-label p {
    margin: 0;
}
.SI-carousel-control-wrapper {
    box-sizing: border-box;
    font-family: 'Nimbus Sans Light', sans-serif;
}
.SI-carousel-control {
    position: relative;
    border-bottom: 4px solid #086ea1;

    display: flex;
    justify-content: center;
    font-size: 22px;
    padding: 8px 0 5px;
    min-height: 40px;
}
.SI-carousel-control > div,
.SI-carousel-control > a {
    float: left;
}
.SI-carousel-control div {
    box-sizing: border-box;
    line-height: 26px;
    padding: 0 10px 0;
    width: 95%;
    color: #086ea1;
    font-weight: 400;
    text-align: center;
}
.SI-carousel-control a {
    color: #767676;
}
.left-arrow {
    position: absolute;
    /*top:5px;*/
    left: 0;
    width: 10px;
    height: 25px;
}
.right-arrow {
    width: 10px;
    height: 24px;
    position: absolute;
    right: 0;
    -webkit-transform: rotate(180deg);
            transform: rotate(180deg);
}
.SI-carousel-control p {
    margin: 0;
}
.screener-footer-small-lt {
    padding: 8px 0;
    font-family: 'Nimbus Sans Light', sans-serif;
    font-size: 14px;
    line-height: 16px;
}
.claim {
    min-height: 40px;
}
@media (min-width: 769px) {
    .SI-hidden-sm {
        display: none;
    }
}
@media (max-width: 769px) {
    .hidden-in-sm {
        display: none;
    }
}
/*stylelint-enable*/
@media (max-width: 1080px) {
    .readybanner a {
        margin-left: 0;
        margin-right: 0;
    }

    .decenter {
        display: block;
    }

    .directlandingpage {
        display: inherit;
    }

    .info-col {
        display: block;
        padding: calc(8px * 2);
        padding-top: 0;
        margin-top: 0;
    }

    .img-col,
    .hide-me {
        display: none;
    }
    .text-col {
        flex: 100%;
        margin-left: auto;
        margin-right: auto;
    }
    .text-col-body {
        max-width: 100%;
        padding-left: 20px;
        padding-right: 20px;
    }
    h1 {
        font-size: 36px;
    }
    h2 {
        font-size: 20px;
    }

    .text-col .ready-wrapper,
    .text-col .browse-all {
        display: block;
    }

    .claim {
        min-height: 20px;
    }
}
@media (max-width: 720px) {
    .modal {
        width: 100%;
    }
    .tab-label br {
        display: block;
    }

    .directlandingpage {
        padding: 0;
    }

    .iclass-disclaimer {
        padding: 0;
    }

    .browse-all-container {
        display: flex;
        flex-direction: column;
    }

    .browse-all.sf-custom {
        align-self: flex-start;
        padding: 0;
        border: 0;
        margin: 8px 0;
    }

    /* stylelint-disable */
    p {
        font-size: 16px;
    }
    .ready-wrapper span {
        font-size: 16px;
    }
    .ready-wrapper a {
        font-size: 16px;
    }
    .SI-tabview-container .SI-tab-label a {
        font-size: 16px;
    }
    h2 {
        font-size: 16px;
    }

    /* stylelint-enable */
}
`;

export default styles;